import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { Ng5SliderModule } from 'ng5-slider';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import {NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ApiClient } from "./shared/api-client.service";
import { Utils } from "./shared/utils";
import { DirectiveModule } from "@bt/directives/directive.module";
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { CoreModule } from "./core";
import { LoginModule, RegistrationModule, BrandModule, RestoreModule, ActivateModule } from "./public";
import { LoginGuard } from './login.guard';
import { ChangePasswordModule } from './public/change-password';
import { SidebarModule } from '@bt/sidebar';
import { AdministrationModule } from "./administration";
import { ProfileModule } from "./profile";
import { PushNotificationModule, PushNotificationEditorModule } from "./push-notification";
import { AppRoutingModule } from "./app-routing.module";
import { AuthGuard,AuthGuardLoad } from "./auth.guard";
import { LoadPageResolve } from './loadPageResolve';
import { UserGuard } from "./user.guard";
import { CreateAdminModule } from './superadmin/create-admin';
import { UsersProfileModule } from './users-profile';
import { InviteUserModule } from "./admin/invite-user";
import { CreateUserModule } from './admin/create-user';
import { AllUsersModule } from "./admin/all-users";
import { ReactiveFormsModule } from '@angular/forms';
import { DeactivateGuardService } from './deactivate.guard';
import { DomainsComponent } from './domains';
import { NewdomainModule } from './newdomain';
import { StatisticsModule } from './statistics/statistics.module';
import { ReferralModule } from './referral/referral.module';
import { SettingsModule } from './settings/settings.module';
import { FinanceModule } from './finance/finance.module';
import { ConfirmModalContent, ConfirmModule} from './finance/confirm-modal';
import { GeoModule } from './geo';
import { GeoEditorModule } from './geo/geo-editor';
import { PushNotifSectionModule } from './push-notif-section';
import { LegalDomainModule } from './legal-domain';

const customNotifierOptions: NotifierOptions = {
  position: {
		horizontal: {
			position: 'right',
			distance: 20
		},
		vertical: {
			position: 'bottom',
			distance: 12,
			gap: 10
		}
	},
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  declarations: [
    AppComponent,
    DomainsComponent,


  ],
  imports: [
    RouterModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule.forRoot(),
    NgbModule.forRoot(),
    AppRoutingModule,
    ReactiveFormsModule,
    Ng5SliderModule,
    FormsModule,
    LoginModule,
    BrandModule,
    RegistrationModule,
    RestoreModule,
    InviteUserModule,
    HttpModule,
    AllUsersModule,
    ActivateModule,
    AdministrationModule,
    ProfileModule,
    CreateUserModule,
    ChangePasswordModule,
    SidebarModule,
    CreateAdminModule,
    DirectiveModule,
    NotifierModule.withConfig(customNotifierOptions),
    UsersProfileModule,
    AllUsersModule,
    FontAwesomeModule,
    PushNotificationModule,
    PushNotificationEditorModule,
    NewdomainModule,
    StatisticsModule,
    ReferralModule,
    SettingsModule,
    FinanceModule,
    ConfirmModule,
    GeoModule,
    GeoEditorModule,
    PushNotifSectionModule,
    LegalDomainModule,
   ],
  providers: [AuthGuard,AuthGuardLoad, ApiClient, Utils, LoginGuard, UserGuard, LoadPageResolve,DeactivateGuardService ],
  bootstrap: [AppComponent],

  entryComponents: [
    ConfirmModalContent,
 ]

})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts